// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"326":"0c223657","477":"c6d2cfc3","936":"46affa27"}[chunkId] + ".js";
};